import { useAtom } from "jotai/react";
import { LayoutStylesStore } from "../../../legacy/stores/layout/layout-styles.store";

function useLayoutStylesStore() {
  const [layoutStyles, setLayoutStyles] = useAtom(LayoutStylesStore);

  return {
    layoutStyles,
    setLayoutStyles,
  };
}

export default useLayoutStylesStore;
